export default __webpack_public_path__ + "5799879053cfe0e60777fa5e9f7197d9.png";